import { useEffect } from 'react';

/**
 * 控制页面滚动行为的自定义Hook
 * 当需要禁用页面滚动时使用，组件卸载时自动恢复
 * @param {boolean} enabled - 是否启用滚动控制，默认为 true
 */
const useBodyScrollControl = (enabled = true) => {
    useEffect(() => {
        if (!enabled) return;

        // 无论侧边栏是否打开，都禁止页面滚动
        document.body.style.overflow = 'hidden';

        // 组件卸载时恢复默认滚动行为和清理CSS变量
        return () => {
            document.body.style.overflow = '';
            document.documentElement.style.removeProperty('--sidebar-space');
        };
    }, [enabled]);
};

export default useBodyScrollControl;
